import React from 'react';
import { observer } from 'mobx-react-lite';
import globalUserProfile from '../../../../stores/global-user-profile';
import { ProfessorLecturesCalendar } from '../../../../pages/user-page/pages/lecturer/lectures-calendar/professor-lectures-calendar';

export const MyLecturesCalendarProfessor = observer(() => {
  if (!globalUserProfile.userProfile?.userWithRole?.id) {
    return <div>Loading user profile...</div>;
  }

  return (
    <ProfessorLecturesCalendar
      professorId={globalUserProfile.userProfile.userWithRole.id}
    />
  );
});
